import { render, staticRenderFns } from "./GramContactMail.vue?vue&type=template&id=406efc06"
import script from "./GramContactMail.vue?vue&type=script&lang=ts"
export * from "./GramContactMail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports